import {ValueObject} from '@s-ui/domain'

export class MarketedVersionsListValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array<MarketedVersionValueObject>} params.items
   * */
}
